import React from 'react';
import { FadeIn } from './FadeIn';
import { Gift, CheckCircle2, Search, Handshake, Palette } from 'lucide-react';
interface PremiumBonus {
  image: string;
  alt: string;
  title: string;
  description: string;
  features: string[];
}
export function PremiumBonuses() {
  const bonuses: PremiumBonus[] = [{
    image: 'https://cdn.magicpatterns.com/uploads/b8DcMUjoXnXcZzVqDKwF1C/Bono_1.png',
    alt: 'Bono 1: Proveedores Verificados en China',
    title: 'PROVEEDORES VERIFICADOS EN CHINA',
    description: 'Accede a un sistema paso a paso para encontrar proveedores confiables sin perder tiempo ni correr riesgos innecesarios.',
    features: ['Identifica proveedores reales y verificados', 'Evita estafas y errores comunes', 'Ahorra tiempo en búsqueda', 'Empieza con bases seguras desde el inicio']
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/eRiZUJUuWPnYYjXuVNYawJ/bono_2.png',
    alt: 'Bono 2: Negociación con Proveedores Chinos',
    title: 'NEGOCIACIÓN CON PROVEEDORES CHINOS',
    description: 'Aprende cómo negociar de forma estratégica para reducir costos, mejorar condiciones y aumentar tus ganancias desde el primer pedido.',
    features: ['Cómo bajar precios de forma inteligente', 'Cómo negociar MOQ y condiciones', 'Cómo comunicarte correctamente con proveedores', 'Cómo cerrar acuerdos más rentables']
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/mZTyhXKThhJKasPo5vvCTL/bono_3.png',
    alt: 'Bono 3: Branding Profesional',
    title: 'BRANDING PROFESIONAL',
    description: 'Crea una marca que se vea confiable, profesional y lista para vender desde el primer momento.',
    features: ['Diseño de logo y nombre de marca', 'Identidad visual atractiva', 'Diferenciación frente a la competencia', 'Construcción de una marca que vende']
  }];
  return <section className="bg-brand-green py-24 px-6 relative overflow-hidden" data-id="element-242">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-243">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-brand-gold rounded-full blur-3xl" data-id="element-244"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-brand-beige rounded-full blur-3xl" data-id="element-245"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-246">
        {/* Header */}
        <FadeIn data-id="element-247">
          <div className="text-center mb-16" data-id="element-248">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 rounded-full mb-6" data-id="element-249">
              <Gift className="w-8 h-8 text-brand-gold" data-id="element-250" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-251">
              🎁 ACCESO A BONOS PREMIUM (INCLUIDOS)
            </h2>
            <p className="text-lg md:text-xl text-white/60 max-w-3xl mx-auto leading-relaxed" data-id="element-252">
              Además de la guía principal, recibirás herramientas prácticas
              diseñadas para ayudarte a avanzar más rápido, tomar mejores
              decisiones y evitar errores que le cuestan dinero a la mayoría de
              principiantes.
            </p>
          </div>
        </FadeIn>

        {/* Bonus Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-253">
          {bonuses.map((bonus, index) => <FadeIn key={index} delay={0.15 * index} data-id="element-254">
              <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden h-full flex flex-col hover:border-brand-gold/30 transition-colors" data-id="element-255">
                {/* Image */}
                <div className="p-5 pb-0" data-id="element-256">
                  <img src={bonus.image} alt={bonus.alt} className="w-full h-auto rounded-xl object-contain" data-id="element-257" />
                </div>

                {/* Content */}
                <div className="p-8 pt-5 flex flex-col flex-1" data-id="element-258">
                  {/* Title */}
                  <h3 className="text-lg md:text-xl font-bold text-white mb-3" data-id="element-259">
                    {bonus.title}
                  </h3>

                  {/* Description */}
                  <p className="text-white/50 text-sm md:text-base leading-relaxed mb-6" data-id="element-260">
                    {bonus.description}
                  </p>

                  {/* Features */}
                  <div className="space-y-3 mt-auto" data-id="element-261">
                    {bonus.features.map((feature, i) => <div key={i} className="flex items-start gap-3" data-id="element-262">
                        <CheckCircle2 className="w-4 h-4 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-263" />
                        <span className="text-sm text-white/80 font-medium" data-id="element-264">
                          {feature}
                        </span>
                      </div>)}
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}